import styled from 'styled-components/macro';

export const StyledDownloadResults = styled.div`

`;
